import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

import BreadCrumb, { BreadcrumbDepth } from '@/components/atomic/molecules/Breadcrumb'

export interface DoctorDetailBreadcrumbProps {
  hospitalName: string
  hospitalId: number
}

export const DoctorDetailBreadcrumb = ({ hospitalName, hospitalId }: DoctorDetailBreadcrumbProps): JSX.Element => {
  const { t } = useTranslation()
  const router = useRouter()

  const breadcrumbDepths: BreadcrumbDepth[] = [
    {
      text: '',
      href: '/',
    },
    {
      text: t('pages.doctorDetail.hospital'),
      href: '/hospitals',
    },
    {
      text: hospitalName,
      href: `/hospitals/${hospitalId}`,
    },
    {
      text: t('pages.doctorDetail.doctorInfo'),
      href: '',
    },
  ]

  return (
    <BreadCrumb
      data-testid="breadcrumb"
      className="!p-[26px]"
      depth={breadcrumbDepths}
      movePage={(href) => {
        router.push(href)
      }}
    />
  )
}
